import {
  GET_CHATS,
  GET_CHATS_FAIL,
  GET_CHATS_SUCCESS,
  GET_GROUPS,
  GET_GROUPS_FAIL,
  GET_GROUPS_SUCCESS,
  GET_CONTACTS,
  GET_CONTACTS_FAIL,
  GET_CONTACTS_SUCCESS,
  GET_MESSAGES,
  GET_MESSAGES_FAIL,
  GET_MESSAGES_SUCCESS,
  POST_ADD_MESSAGE,
  POST_ADD_MESSAGE_FAIL,
  POST_ADD_MESSAGE_SUCCESS,
  DELETE_MESSAGE,
  DELETE_MESSAGE_SUCCESS,
  DELETE_MESSAGE_FAIL
} from "./actionTypes"

export const getChats = () => ({
  type: GET_CHATS,
})

export const getChatsSuccess = (chats: any) => ({
  type: GET_CHATS_SUCCESS,
  payload: chats,
})

export const getChatsFail = (error: any) => ({
  type: GET_CHATS_FAIL,
  payload: error,
})

export const getGroups = () => ({
  type: GET_GROUPS,
})

export const getGroupsSuccess = (groups: any) => ({
  type: GET_GROUPS_SUCCESS,
  payload: groups,
});

export const getGroupsFail = (error: any) => ({
  type: GET_GROUPS_FAIL,
  payload: error,
})

export const getContacts = () => ({
  type: GET_CONTACTS,
})

export const getContactsSuccess = (contacts: any) => ({
  type: GET_CONTACTS_SUCCESS,
  payload: contacts,
})

export const getContactsFail = (error: any) => ({
  type: GET_CONTACTS_FAIL,
  payload: error,
})

export const getMessages = (roomId: any) => ({
  type: GET_MESSAGES,
  roomId,
})

export const getMessagesSuccess = (messages: any) => ({
  type: GET_MESSAGES_SUCCESS,
  payload: messages,
})

export const getMessagesFail = (error: any) => ({
  type: GET_MESSAGES_FAIL,
  payload: error,
})

export const addMessage = (message: any) => ({
  type: POST_ADD_MESSAGE,
  message,
})

export const addMessageSuccess = (message: any) => ({
  type: POST_ADD_MESSAGE_SUCCESS,
  payload: message,
})

export const addMessageFail = (error: any) => ({
  type: POST_ADD_MESSAGE_FAIL,
  payload: error,
})

export const deleteMessage = (data: any) => ({
  type: DELETE_MESSAGE,
  payload: data,
})

export const deleteMessageSuccess = (data: any) => ({
  type: DELETE_MESSAGE_SUCCESS,
  payload: data,
})

export const deleteMessageFail = (error: any) => ({
  type: DELETE_MESSAGE_FAIL,
  payload: error,
})

